<div class="energy-wrapper">
    <div class="green-energy-placeholder">
        @if (isGreenHome()) {
            <div class="green-energy-icon info-icon" (click)="showGreenEnergyTooltip()">
                <ev-tooltip-img
                    class="area-tooltip"
                    [imgUrl]="greenEnergyTooltipImgUrl"
                    [visible]="greenEnergyTooltipVisible()"
                    [left]="43"
                    [arrow]="'left'"
                    [arrowTopAlign]="16"
                    (close)="hideGreenEnergyTooltip()"
                >
                    Boligen oppfyller et av kriteriene for Grønn bolig: {{ greenHomeDescription() }}.
                    <br />
                    <a href="{{ greenHomeArticleUrl }}" target="_blank"
                        >Les mer om hvordan Eiendomsverdi klassifiserer grønne boliger her.<span class="external-link"></span
                    ></a>
                </ev-tooltip-img>
            </div>
        }
    </div>
    <sergeant-title [title]="'Energimerke'" (showMoreClicked)="goToEnergyUsage()"></sergeant-title>
    @let energyrating = energyRating();
    @if (energyrating) {
        <div class="energy-data energy-rating">
            <div class="keyinfo__energy__data__descriptor">
                {{ energyrating.energyLabel }}
                @if (energyrating.energyLabelVersion !== EnergyLabelVersion.Version2026) {
                    {{ energyrating.energyLabelingColorDescription }}
                }
            </div>
            @if (energyrating.energyLabel !== "ukjent") {
                @if (energyrating.isExpired) {
                    <div class="energy-data-descriptor">UTGÅTT</div>
                }
                <div
                    class="energy-label-icon energy-label-icon-infocard"
                    [class]="[energyrating.isExpired ? 'expired-energy-label' : 'none-expired-energy-label', energyrating.energyLabelCss]"
                    (click)="openScoreInformation($event)"
                ></div>

                <ev_tooltip
                    [visible]="scoreTooltipOpen"
                    [right]="-5"
                    [top]="44"
                    [arrow]="'top'"
                    [arrowAlignRight]="22"
                    [arrowTopAlign]="-8"
                    [title]="'Energimerke'"
                    (close)="closeScoreInformation()"
                >
                    <div class="energylabel-popup score-popup">
                        <div class="keyvalue-pair">
                            <div>Energimerke</div>
                            <div class="energy-label-popup-row">
                                <div class="energy-label-popup-row-text">
                                    @if (energyrating.isExpired) {
                                        <div class="energy-label-icon-popup-expired">Utgått</div>
                                    }
                                </div>
                                <div
                                    class="energy-label-icon energy-label-icon-popup"
                                    [class]="[energyrating.isExpired ? 'expired-energy-label' : 'none-expired-energy-label', energyrating.energyLabelCss]"
                                ></div>
                            </div>
                        </div>
                        <div class="keyvalue-pair">
                            @if (energyrating.source == "Enova") {
                                <div class="key">Utstedt</div>
                            } @else {
                                <div class="key">Annonsert</div>
                            }
                            <div>{{ energyrating.labelDate | date: "dd.MM.yyyy" }}</div>
                        </div>
                        <div class="keyvalue-pair">
                            <div>Kilde</div>
                            <div>{{ energyrating.source }}</div>
                        </div>
                    </div>
                </ev_tooltip>
            } @else {
                <div class="energy-label-icon unknown"></div>
            }
        </div>
    }
</div>
